import webBiLogger from '@wix/web-bi-logger';
import { openaiApiCallAttempt } from '@wix/bi-logger-tools/v2';

/* eslint-disable camelcase */

const logger = webBiLogger.factory().logger();

export class BNGBiReporter {
  reportBNGOpenaiApiCallAttempt(
    parameters: any,
    promptType: string,
    results: any,
    retryCount: number,
    status: string,
    key: string,
    toolName: string,
    url: string,
  ) {
    logger.report(
      openaiApiCallAttempt({
        parameters: JSON.stringify(parameters),
        promptType,
        results,
        retryCount,
        status_name: status,
        key,
        toolName,
        url,
      }),
    );
  }
}

/* eslint-enable camelcase */
